import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const WinTiltAndTurnOption = ({ value, onChange, id='WinTiltAndTurnOption', label = 'Tilt and Turn Option', disabled = false }) => {
    const [selectedWinTiltAndTurnOption, setSelectedWinTiltAndTurnOption] = useState(value || "Right Only");
    const [doorData, setDoorData] = useState(null);

    const handleWinTiltAndTurnOptionChange = (e) => {
        setSelectedWinTiltAndTurnOption(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor={id}>{label}</label>
            <select
                disabled={disabled}
                id={id}
                value={selectedWinTiltAndTurnOption}
                onChange={handleWinTiltAndTurnOptionChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="Right Only">{selectedWinTiltAndTurnOption === "Right Only" ? "Right Only ✔" : "Right Only"}</option>
                <option value="Left Only">{selectedWinTiltAndTurnOption === "Left Only" ? "Left Only ✔" : "Left Only"}</option>
                <option value="Right + Tilt">{selectedWinTiltAndTurnOption === "Right + Tilt" ? "Right + Tilt ✔" : "Right + Tilt"}</option>
                <option value="Left + Tilt">{selectedWinTiltAndTurnOption === "Left + Tilt" ? "Left + Tilt ✔" : "Left + Tilt"}</option>
                <option value="Fixed">{selectedWinTiltAndTurnOption === "Fixed" ? "Fixed ✔" : "Fixed"}</option>
            </select>
        </div>
    );
};

export default WinTiltAndTurnOption;
